import { render, staticRenderFns } from "./ProductScreen.vue?vue&type=template&id=7274d721&scoped=true&"
import script from "./ProductScreen.vue?vue&type=script&lang=js&"
export * from "./ProductScreen.vue?vue&type=script&lang=js&"
import style0 from "./ProductScreen.vue?vue&type=style&index=0&id=7274d721&prod&lang=css&"
import style1 from "./ProductScreen.vue?vue&type=style&index=1&id=7274d721&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274d721",
  null
  
)

export default component.exports